import { isString, isEmpty } from "lodash";

import store from "../../../../store";
import { getAuthUserAccount } from "../../../features/application";
import AuthApi from "../../../services/api/auth";
import UserApi from "../../../services/api/user";
import { setAppSnackNotification } from "../../../store/actions/application";
import { validateSyncEmailAddress } from "../../../utils/field-validator";
import AppLogger from "../../../utils/logger";
import PageConfig from "../configs";

const addNewEmailAddress = async ({
  email,
  submitCount,
  t,
  setProcessing,
  setFormUIState,
  setSubmitCount,
  setToken,
  setRetryTimeout,
  setEmailFieldError,
  setIgnoredTriggerOTP,
}) => {
  try {
    const errorsCollector = validateSyncEmailAddress({
      emailAddress: email,
      config: {
        t,
        required: true,
        fieldName: "email",
      },
      errorsCollector: {},
    });
    if (isString(errorsCollector.email) && !isEmpty(errorsCollector.email)) {
      setEmailFieldError(errorsCollector.email ?? "");
      return;
    }
    const { FORM_UI_STATE } = PageConfig;
    setProcessing(true);
    const response = await UserApi.postUserEmail({
      email,
      addUnverified: true,
    });
    if (response.success) {
      setToken(response.body?.id);
      setRetryTimeout(response.body?.retryIn || 30);
      setFormUIState(FORM_UI_STATE.VERIFY_OTP);
      setIgnoredTriggerOTP(true);
    } else {
      const fieldError = generateAuthUpdateEmailError({
        apiResponse: response,
        t,
      });
      console.log(">>>> fieldError ", fieldError);
      setEmailFieldError(fieldError);
    }
    setSubmitCount(submitCount + 1);
  } catch (error) {
    AppLogger.exception(error);
    setEmailFieldError(t("errors.unknownErrorOccurred"));
  } finally {
    setProcessing(false);
  }
};

const generateAuthUpdateEmailError = ({ apiResponse, t }) => {
  const errorCode = apiResponse.body?.code;
  let fieldError = "";
  switch (errorCode) {
    case 1201:
      fieldError = t("settingPage.tooManyAttemptsTimeCountDown", {
        timeCountDown: apiResponse.body?.retryIn || 30,
      });
      break;
    case 1202:
      fieldError = t("settingPage.verificationCodeInvalid");
      break;
    case 1108:
      fieldError = t("settingPage.emailUserByAnotherAccount");
      break;
    default:
      fieldError = t("errors.unknownErrorOccurred");
      break;
  }
  return fieldError;
};

const triggerOTP = async ({
  emailAddress,
  setFormUIState,
  ignoredTriggerOTP,
  setIgnoredTriggerOTP,
  setProcessing,
  setToken,
  setRetryTimeout,
  t,
  setEmailFieldError,
}) => {
  try {
    const { FORM_UI_STATE } = PageConfig;
    if (ignoredTriggerOTP) {
      setFormUIState(FORM_UI_STATE.VERIFY_OTP);
      return;
    }
    setProcessing(true);
    const response = await AuthApi.updateEmail({ emailAddress });
    if (response.success) {
      setToken(response.body?.id);
      setRetryTimeout(response.body?.retryIn || 30);
      setFormUIState(FORM_UI_STATE.VERIFY_OTP);
      setIgnoredTriggerOTP(false);
    } else {
      const fieldError = generateAuthUpdateEmailError({
        apiResponse: response,
        t,
      });
      setEmailFieldError(fieldError);
    }
  } catch (error) {
    AppLogger.exception(error);
  } finally {
    setProcessing(false);
  }
};

const verifyOTP = async ({
  token,
  oneTimePassword,
  setProcessing,
  history,
  t,
  setOtpFieldError,
}) => {
  try {
    setProcessing(true);
    const apiResponse = await AuthApi.verifyEmailByOTP({
      token,
      otp: oneTimePassword,
    });
    if (apiResponse.success) {
      store.dispatch(
        setAppSnackNotification({
          severity: "success",
          message: t("common.updatedsuccessfully"),
        })
      );
      store.dispatch(getAuthUserAccount());
      history.push("/complete-your-ad");
    } else {
      const errorCode = apiResponse.body?.code;
      switch (errorCode) {
        case 1202:
          setOtpFieldError(t("settingPage.verificationCodeInvalid"));
          break;
        default:
          setOtpFieldError(t("errors.unknownErrorOccurred"));
          break;
      }
    }
  } catch (error) {
    AppLogger.exception(error);
  } finally {
    setProcessing(false);
  }
};

const PageDomain = {
  addNewEmailAddress,
  triggerOTP,
  verifyOTP,
};

export default PageDomain;
